module.exports = __webpack_public_path__ + "static/media/bourbonSt.92243f62.jpeg";